import { render } from "./HeroiconsSolidBriefcase.vue?vue&type=template&id=b0f6f61c"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBriefcase.vue"]])

export default __exports__